export const PAYMENT_PERIODS = [
  { value: "sekali", label: "Satu kali" },
  { value: "bulanan", label: "Per bulan" },
  { value: "tiga_bulan", label: "Tiga bulan" },
  { value: "empat_bulan", label: "Empat bulan" },
  { value: "semester", label: "Per semester" },
  { value: "paket_khusus", label: "Paket khusus" },
];
export const ppLabel = (v) => PAYMENT_PERIODS.find((p) => p.value === v)?.label || v || "-";
export const formatIDR = (n) => "Rp " + Number(n || 0).toLocaleString("id-ID");
export const onlyDigits = (s) => String(s ?? "").replace(/[^0-9]/g, "");
